import { render, staticRenderFns } from "./GlobalSearchIcon.vue?vue&type=template&id=5e0706a5&"
import script from "./GlobalSearchIcon.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemAvatar})
